/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
/**
 * Charging Status of the machine if its good or bad.
 *
 */
export var ChargingSpeedStatus;
(function (ChargingSpeedStatus) {
    ChargingSpeedStatus["GOOD"] = "Good";
    ChargingSpeedStatus["BAD"] = "Bad";
})(ChargingSpeedStatus || (ChargingSpeedStatus = {}));
